module.exports = __webpack_public_path__ + "images/d8a49b8370693ba913868989b0c123d9.png";